module.exports = __webpack_public_path__ + "ToyotaType-Light.6f5971b298c8790b4a43.otf";


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/assets/mygolf-theme/fonts/toyota/ToyotaType-Light.otf
// module id = ../../../../../src/assets/mygolf-theme/fonts/toyota/ToyotaType-Light.otf
// module chunks = styles